module.exports = "<div class=\"analytics-container\" style=\"background-color: #eaeaec\">\r\n  <div class=\"analytics-inner-container\">\r\n    <div ng-if=\"vm.isLoading\" style=\"text-align: center; margin-top: 10rem;\">\r\n      <i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i>\r\n    </div>    \r\n    <div ng-if=\"!vm.isLoading\">\r\n      Coming soon...              \r\n    </div>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/containers/analytics-traffic/analytics-traffic.html
 ** module id = 936
 ** module chunks = 0
 **/